// import TextField from '@mui/material/TextField';
// import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { BootstrapInput, BootstrapFormControl } from "./StyledForm";
import Tooltip, {TooltipContent, TooltipTrigger} from "../Tooltip";
import {TextFieldTitle} from "../TextComponent/StyledTextField";
import React from "react";

const Textbox = ({
    defaultvalue,
    formlabel,
    display,
    placeholder,
    onChange,
    disabled,
    showDetail,
    tooltipContent,
}) => {
    return (
        <BootstrapFormControl display={display} disabled={disabled}>
            <div>
                {formlabel !== undefined ? <FormLabel>{formlabel}</FormLabel> : ``}
                {showDetail?

                    <Tooltip id="track-tip">
                        <TooltipTrigger>
                            <i className="fas fa-question-circle"></i>
                        </TooltipTrigger>
                        <TooltipContent>
                            {/*Minimum query coverage of the alignment.*/}
                            {tooltipContent !== undefined? tooltipContent:'Minimum query coverage of the alignment.'}
                        </TooltipContent>
                    </Tooltip>
                    :''}
            </div>


            <BootstrapInput
                display={display}
                disabled={disabled}
                defaultValue={defaultvalue}
                onChange={onChange}
                placeholder={placeholder}
            />
        </BootstrapFormControl>
    );
};

export default Textbox;
